import { render, staticRenderFns } from "./TDProjects.vue?vue&type=template&id=0af1cbc1"
import script from "./TDProjects.vue?vue&type=script&lang=js"
export * from "./TDProjects.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports